export default __webpack_public_path__ + "static/image-API-interview-50faa46c1f85abf1d45ac70b37bf2305.png";